module.exports = __webpack_public_path__ + "static/img/avatar-5.2edb920b.png";